import { clearAuthSession, getAuthToken, getCsrfToken, hasWebAuthSession } from "@/lib/auth";
import { authApi } from "@/lib/axios";
import { storage } from "@/utils/storage";

type LogoutRequest = (config: {
  headers: Record<string, string>;
  timeout: number;
  __skipAuthRedirect: boolean;
}) => Promise<unknown>;

const requestBackendLogout: LogoutRequest = (config) =>
  authApi.post("/users/users/logout/", {}, config);

export const logoutCurrentUser = async (
  request: LogoutRequest = requestBackendLogout
): Promise<void> => {
  const token = getAuthToken();
  const csrfToken = getCsrfToken();
  const headers: Record<string, string> = {};

  // Cookie sessions may have an obsolete per-tab token after another login.
  // Authenticate logout with the current shared cookie instead.
  if (token && !hasWebAuthSession()) headers.Authorization = `Token ${token}`;
  if (csrfToken) headers["X-CSRFToken"] = csrfToken;

  // Clear browser-visible identity before any network wait. The backend call
  // may stall or fail, but it must never keep the previous user signed in.
  clearAuthSession();
  storage.removeItem("user_info");

  try {
    await request({
      headers,
      timeout: 5_000,
      __skipAuthRedirect: true,
    });
  } catch {
    // The local session is already gone. A later login replaces a stale
    // HttpOnly cookie even when the best-effort server logout is unavailable.
  }
};
